import { render } from "./ProductStoreActionsPopover.vue?vue&type=template&id=2a0af910&ts=true"
import script from "./ProductStoreActionsPopover.vue?vue&type=script&lang=ts"
export * from "./ProductStoreActionsPopover.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__